import React from 'react';
import { device } from '../../utils/responsive_utilities';
import Styled from 'styled-components';
import { fontQuicksand } from './mixin';
import AmexIcon from '~images/stripe-payment-element/amex.svg';
import DinerClubInternationalIcon from '~images/stripe-payment-element/diners-club-international.svg';
import DiscoverIcon from '~images/stripe-payment-element/discover.svg';
import JCBIcon from '~images/stripe-payment-element/jcb.svg';
import MastercardIcon from '~images/stripe-payment-element/mastercard.svg';
import VisaIcon from '~images/stripe-payment-element/visa.svg';
import CartesBancairesIcon from '~images/stripe-payment-element/cartes-bancaires.svg';
import EftposIcon from '~images/stripe-payment-element/eftpos.svg';
import ChinaUnionPayIcon from '~images/stripe-payment-element/china-union-pay.svg';
import GPayIcon from '~images/stripe-payment-element/google-pay.svg';
import ApplePayIcon from '~images/stripe-payment-element/apple-pay.svg';
import Image from '../loggedout/common/Image';

const SavedPaymentMethodsContainer = ({
  settings,
  selectedPaymentMethodId,
  selectPaymentMethod,
  addPaymentMethodText = '+ Add New Payment Details',
  setPaymentElementError,
  order
}) => {
  let paymentMethodList = settings.stripePaymentMethods;
  if (order === "defaultPaymentMethodFirst") {
    paymentMethodList.sort((a, b) => (a.is_default === b.is_default ? 0 : a.is_default ? -1 : 1));
  }

  return (
    paymentMethodList.length > 0 && (
      <SavedPaymentMethodsWrapper
        className="payment-options"
        id="paymentOptions"
      >
        {paymentMethodList.map((val) => (
          <SavedPaymentMethodItem
            paymentMethod={val}
            selectPaymentMethod={selectPaymentMethod}
            selectedPaymentMethodId={selectedPaymentMethodId}
            setPaymentElementError={setPaymentElementError}
          />
        ))}
        {selectedPaymentMethodId && (
          <SavedPaymentMethod onClick={() => selectPaymentMethod(null)}>
            {/* <a className="add-new-card" role="button" > */}
            {addPaymentMethodText}
            {/* </a> */}
          </SavedPaymentMethod>
        )}
      </SavedPaymentMethodsWrapper>
    )
  );
};

const SavedPaymentMethodItem = function ({
  paymentMethod,
  selectPaymentMethod,
  selectedPaymentMethodId,
  setPaymentElementError
}) {
  let isSelected = selectedPaymentMethodId == paymentMethod.stripe_id;
  let type = paymentMethod.type;
  let cardWalletType = paymentMethod.card_wallet_type; // google_pay, apple_pay,nil
  let cardBrand = type ==='card' ? paymentMethod.card.brand.replace(/\s+/g, '-').toLowerCase(): null;

  let savedPaymentMethodElement = null;

  const getCardBrandIcon = () => {
    if (type !== 'card') {
      return null;
    }
    let cardBrandIcon = null; 
    switch (cardBrand) {
      case 'visa':
        cardBrandIcon = <Image src={VisaIcon} />;
        break;
      case 'mastercard':
        cardBrandIcon = <Image src={MastercardIcon} />;
        break;
      case 'amex':
        cardBrandIcon = <Image src={AmexIcon} />;
        break;
      case 'discover':
        cardBrandIcon = <Image src={DiscoverIcon} />;
        break;
      case 'diners':
        cardBrandIcon = <Image src={DinerClubInternationalIcon} />;
        break;
      case 'jcb':
        cardBrandIcon = <Image src={JCBIcon} />;
        break;
      case 'cartes_bancaires':
        cardBrandIcon = <Image src={CartesBancairesIcon} />;
        break;
      case 'eftpos_au':
        cardBrandIcon = <Image src={EftposIcon} />;
        break;
      case 'unionpay':
        cardBrandIcon = <Image src={ChinaUnionPayIcon} />;
        break;
    }
    if (cardBrandIcon) {
      return <CardBrandIconWrapper>{cardBrandIcon}</CardBrandIconWrapper>;
    }
  }
  
  const getDisplayIcon = () => {
    if (type === 'card') {
      switch (cardWalletType) {
        case 'google_pay':
          return <WalletIconsWrapper width="4.5rem"><Image src={GPayIcon}/></WalletIconsWrapper>;
        case 'apple_pay':
          return <WalletIconsWrapper><Image src={ApplePayIcon}/></WalletIconsWrapper>;
        default: 
          return null;
      }
    } 
  };
  
  if (type == 'card') {
    
    savedPaymentMethodElement = (
      <SavedPaymentMethod
        isSelected={isSelected}
        onClick={() => {
          selectPaymentMethod(paymentMethod.stripe_id);
          setPaymentElementError(null);
        }}
      >
        <div>
          <input type="radio" checked={isSelected} />
          <label>
            {getCardBrandIcon()}
            <p>
              <span className="hidden-card-nmbr">**** **** ****</span>{' '}
              {paymentMethod.card.last4}
            </p>
            {/* <span>{` $`}</span> */}
          </label>
        </div>
        {getDisplayIcon()}
      </SavedPaymentMethod>
    );
  }

  return savedPaymentMethodElement;
};

export const SavedPaymentMethod = Styled.li`
  cursor: pointer;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  background-color: ${(props) =>
    props.isSelected ? 'rgba(79, 82, 195, 0.4)' : 'transparent'};
  margin-bottom: 1.6rem;
  border: 1px solid #6E71DD;
  border-radius: 1.2rem;
  height: 7.2rem;
  padding: 0 2.4rem;
  ${fontQuicksand(1.6, 2, 7)};
  color: #fff;
  .card-brand-logo-new-page {
    padding: 0;
    width: 5.5rem;
    height: 4rem;
  }
  input[type="radio"] {
    opacity: 0;
    width:0;
    height:0;

  }
  input[type="radio"]:checked + label::after {
    border-width: 4px;
    background-color: #2284E2;
  }

  label {
    cursor: pointer;
    position: relative;
    padding-left: 2rem;
    display: inline-block;
    &:after {
      content: '';
      width: 1.6rem;
      height: 1.6rem;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      border: 1px solid #fff;
      border-radius: 50%;
      box-sizing: border-box;
      background-color: transparent;
    }
  }
  p {
    display: inline-block;
  }
  .hidden-card-nmbr {
    ${fontQuicksand(2.4, 2.8, 7)};
    vertical-align: sub;
  }
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.4, 1.8, 7)};
    height: 4.8rem;
    .hidden-card-nmbr {
    ${fontQuicksand(1.8, 2.2, 7)};
  }
  }
  @media ${device.Phone} {
  ${fontQuicksand(1.4, 1.8, 7)};
  height: 4.8rem;
  .hidden-card-nmbr {
    ${fontQuicksand(1.8, 2.2, 7)};
  }
  }
`;

export const SavedPaymentMethodsWrapper = Styled.ul`
  width: 47rem;
  box-sizing: border-box;
  margin: 0 auto;
  
  @media ${device.PhoneLargeScreen} {
    width: 37rem;
  }
  @media ${device.Phone} {
    width: 34rem;
  }
`;

export const WalletIconsWrapper = Styled.div`
  display: inline-flex;
  width: ${(props) => props.width ? props.width : "4.0rem" };
  height: ${(props) => props.height ? props.height : "3.5rem"};
  overflow: hidden;
  text-align: left;
  background: ${(props) => props.backgroundColor ? props.backgroundColor : 'transparent'};
  border-radius: ${(props) => props.borderRadius ? props.borderRadius : '0rem'};
  & > img {
    width: 100%;
  }
`;

export const CardBrandIconWrapper = Styled.div`
  margin: 0rem 1rem;
  display: inline-flex;
  vertical-align: middle;
  width: 3.5rem;
  height: 3.5rem;
  overflow: hidden;
  & > img {
    width: 100%;
  }
`;

export default SavedPaymentMethodsContainer;
